import './App.css';
import {
  Navigate,
  RouteObject,
  useRoutes
} from "react-router-dom";
import { DashboardFactory } from './presentation/sdp/dashboard/dashboard-factory';
import { DashboardFactory as DashboardScpFactory } from './presentation/scp/dashboard/dashboard-factory';
import { LoginFactory } from './presentation/login/login-factory';
import { OfficialDiarySearchFactory } from './presentation/sdp/official-diary/official-diary-search-factory';
import { OfficialDiaryDetailFactory } from './presentation/sdp/official-diary/official-diary-detail-factory';
import { SubmissionPublicationSearchFactory } from './presentation/sdp/submission-publication/submission-publication-search-factory';
import { OfficialDiaryPublicationFactory } from './presentation/sdp/publication/official-diary-publication-factory';
import { PageNotFoundFactory } from './presentation/page-not-found-factory';
import { PageUnauthorizedFactory } from './presentation/page-unauthorized-factory';
import ApplicationAppService from './application/platform/application-app-service';
import { PurchaseSearchFactory } from './presentation/scp/purchase/purchase-search-factory';
import { PurchaseCreateEditFactory } from './presentation/scp/purchase/purchase-create-edit-factory';
import { IrpSearchFactory } from './presentation/scp/irp/irp-search-factory';
import { IrpCreateEditFactory } from './presentation/scp/irp/irp-create-edit-factory';
import { UnidEntitySearchFactory } from './presentation/scp/unid-entity/unid-entity-search-factory';
import { ContractSearchFactory } from './presentation/scp/contract/contract-search-factory';
import { ContractCreateEditFactory } from './presentation/scp/contract/contract-create-edit-factory';
import { AmendmentListFactory } from './presentation/scp/contract/amendment-list-factory';
import { AmendmentCreateEditFactory } from './presentation/scp/contract/amendment-create-edit-factory';
import { PoliticalPartySearchFactory } from './presentation/sge/political-party/political-party-search-factory';
import { ParlamentarianSearchFactory } from './presentation/sge/parlamentarian/parlamentarian-search-factory';
import { SupplierSearchFactory } from './presentation/sge/supplier/supplier-search-factory';
import { AmendmentSearchFactory as SgeAmendmentSearchFactory } from './presentation/sge/amendment/amendment-search-factory';
import { AmendmentCreateEditFactory as SgeAmendmentCreateEditFactory } from './presentation/sge/amendment/amendment-create-edit-factory';
import { AmendmentDetailFactory } from './presentation/sge/amendment/detail/amendment-detail-factory';
import { BudgetUnitSearchFactory } from './presentation/sge/budget-unit/budget-unit-search-factory';
import { BudgetProgramSearchFactory } from './presentation/sge/budget-program/budget-program-search-factory';
import { BudgetActionSearchFactory } from './presentation/sge/budget-action/budget-action-search-factory';
import { DashboardFactory as SgeDashboardFactory } from './presentation/sge/dashboard/dashboard-factory';
import { MenuFactory as ApmMenuFactory } from './presentation/apm/menu/menu-factory';
import { CustomPageSearchFactory } from './presentation/apm/custom-page/custom-page-search-factory';
import { CustomPageCreateEditFactory } from './presentation/apm/custom-page/custom-page-create-edit-factory';
import { HomeFactory as ApmHomeFactory } from './presentation/apm/home/home-factory';
import { NewsSearchFactory } from './presentation/apm/news/news-search-factory';
import { QuestionAnswerSearchFactory } from './presentation/apm/question-answer/question-answer-search-factory';
import { QuestionAnswerCategoryFactory } from './presentation/apm/question-answer-category/question-answer-category-factory';
import { BannerFactory } from './presentation/apm/banner/banner-factory';
import { AuditSearchFactory } from './presentation/apm/audit/audit-search-factory';
import { GovernmentProjectSearchFactory } from './presentation/apm/government-project/government-project-search-factory';
import { AgreementSearchFactory } from './presentation/apm/agreement/agreement-search-factory';
import { BiddingSearchFactory } from './presentation/apm/bidding/bidding-search-factory';
import { PurchaseContractSearchFactory } from './presentation/apm/purchase-contract/purchase-contract-search-factory';
import { ManagementUnitSearchFactory } from './presentation/apm/management-unit/management-unit-search-factory';
import { PublicAccountSearchFactory } from './presentation/apm/public-account/public-account-search-factory';
import { DashboardFactory as ApmDashboardFactory } from './presentation/apm/dashboard/dashboard-factory';
import { ParametersFactory } from './presentation/apm/parameters/parameters-factory';
import { PublicPortalFactory } from './presentation/public/public-portal-factory';
import { PublicDashboardFactory } from './presentation/public/sge/dashboard/public-dashboard-factory';
import { PublicAmendmentSearchFactory } from './presentation/public/sge/amendment/search/public-amendment-search-factory';
import { PublicAmendmentDetailFactory } from './presentation/public/sge/amendment/detail/public-amendment-detail-factory';

const applicationData = ApplicationAppService.getApplicationData();

const ProtectedRoute = ({ children }: { children: any }) => {
  // Verifica autenticação dinamicamente a cada render
  const authorizationData = ApplicationAppService.getAuthenticationData();

  if (!authorizationData) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

const routesSdp = (): RouteObject[] => {
  var routes: RouteObject[] = [
    {
      path: "/dashboard",
      element: (
        <ProtectedRoute>
          <DashboardFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/remessas-publicacao",
      element: (
        <ProtectedRoute>
          <SubmissionPublicationSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/remessas-publicacao/detalhes/:submissionPublicationId",
      element: (
        <ProtectedRoute>
          <SubmissionPublicationSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/diario-oficial",
      element: (
        <ProtectedRoute>
          <OfficialDiarySearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/diario-oficial/detalhes/:officialDailyId",
      element: (
        <ProtectedRoute>
          <OfficialDiaryDetailFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/diario-oficial/publicar/:submissionPublicationId?",
      element: (
        <ProtectedRoute>
          <OfficialDiaryPublicationFactory />
        </ProtectedRoute>
      )
    },
  ];
  return routes;
}

const routesScp = (): RouteObject[] => {

  var routes: RouteObject[] = [
    {
      path: "/dashboard",
      element: (
        <ProtectedRoute>
          <DashboardScpFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/compras-licitacoes",
      element: (
        <ProtectedRoute>
          <PurchaseSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/compras-licitacoes/publicar/:purchaseId?",
      element: (
        <ProtectedRoute>
          <PurchaseCreateEditFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/intencao-registro-preco",
      element: (
        <ProtectedRoute>
          <IrpSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/intencao-registro-preco/publicar/:irpId?",
      element: (
        <ProtectedRoute>
          <IrpCreateEditFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/unidades-entidade",
      element: (
        <ProtectedRoute>
          <UnidEntitySearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/contratos",
      element: (
        <ProtectedRoute>
          <ContractSearchFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/contratos/:contractId/aditivos",
      element: (
        <ProtectedRoute>
          <AmendmentListFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/contratos/:contractId/aditivos/publicar/:sequentialId?",
      element: (
        <ProtectedRoute>
          <AmendmentCreateEditFactory />
        </ProtectedRoute>
      )
    },
    {
      path: "/contratos/publicar/:contractId?",
      element: (
        <ProtectedRoute>
          <ContractCreateEditFactory />
        </ProtectedRoute>
      )
    },
  ];
  return routes;

}

const routesSge = (): RouteObject[] => {
  return [
    { path: '/dashboard', element: <ProtectedRoute><SgeDashboardFactory /></ProtectedRoute> },
    { path: '/partidos-politicos', element: <ProtectedRoute><PoliticalPartySearchFactory /></ProtectedRoute> },
    { path: '/parlamentares', element: <ProtectedRoute><ParlamentarianSearchFactory /></ProtectedRoute> },
    { path: '/fornecedores', element: <ProtectedRoute><SupplierSearchFactory /></ProtectedRoute> },
    { path: '/emendas', element: <ProtectedRoute><SgeAmendmentSearchFactory /></ProtectedRoute> },
    { path: '/emendas/cadastrar', element: <ProtectedRoute><SgeAmendmentCreateEditFactory /></ProtectedRoute> },
    { path: '/emendas/editar/:amendmentId', element: <ProtectedRoute><SgeAmendmentCreateEditFactory /></ProtectedRoute> },
    { path: '/emendas/:amendmentId', element: <ProtectedRoute><AmendmentDetailFactory /></ProtectedRoute> },
    { path: '/unidades-orcamentarias', element: <ProtectedRoute><BudgetUnitSearchFactory /></ProtectedRoute> },
    { path: '/programas-orcamentarios', element: <ProtectedRoute><BudgetProgramSearchFactory /></ProtectedRoute> },
    { path: '/acoes-orcamentarias', element: <ProtectedRoute><BudgetActionSearchFactory /></ProtectedRoute> },
    {
      path: '/:uf/:citySlug/transparencia',
      element: <PublicPortalFactory />,
      children: [
        { index: true, element: <PublicDashboardFactory /> },
        { path: 'emendas', element: <PublicAmendmentSearchFactory /> },
        { path: 'emendas/:amendmentId', element: <PublicAmendmentDetailFactory /> },
      ],
    },
  ];
};

const routesApm = (): RouteObject[] => {
  return [
    { path: '/dashboard', element: <ProtectedRoute><ApmDashboardFactory /></ProtectedRoute> },
    { path: '/menus', element: <ProtectedRoute><ApmMenuFactory /></ProtectedRoute> },
    { path: '/paginas', element: <ProtectedRoute><CustomPageSearchFactory /></ProtectedRoute> },
    { path: '/paginas/cadastrar', element: <ProtectedRoute><CustomPageCreateEditFactory /></ProtectedRoute> },
    { path: '/paginas/editar/:customPageId', element: <ProtectedRoute><CustomPageCreateEditFactory /></ProtectedRoute> },
    { path: '/home', element: <ProtectedRoute><ApmHomeFactory /></ProtectedRoute> },
    { path: '/noticias', element: <ProtectedRoute><NewsSearchFactory /></ProtectedRoute> },
    { path: '/perguntas-respostas', element: <ProtectedRoute><QuestionAnswerSearchFactory /></ProtectedRoute> },
    { path: '/perguntas-respostas/categorias', element: <ProtectedRoute><QuestionAnswerCategoryFactory /></ProtectedRoute> },
    { path: '/banners', element: <ProtectedRoute><BannerFactory /></ProtectedRoute> },
    { path: '/parametros', element: <ProtectedRoute><ParametersFactory /></ProtectedRoute> },
    { path: '/auditorias', element: <ProtectedRoute><AuditSearchFactory /></ProtectedRoute> },
    { path: '/projetos-governo', element: <ProtectedRoute><GovernmentProjectSearchFactory /></ProtectedRoute> },
    { path: '/convenios-repasses', element: <ProtectedRoute><AgreementSearchFactory /></ProtectedRoute> },
    { path: '/licitacoes', element: <ProtectedRoute><BiddingSearchFactory /></ProtectedRoute> },
    { path: '/contratos', element: <ProtectedRoute><PurchaseContractSearchFactory /></ProtectedRoute> },
    { path: '/unidades-gestoras', element: <ProtectedRoute><ManagementUnitSearchFactory /></ProtectedRoute> },
    { path: '/contas-publicas', element: <ProtectedRoute><PublicAccountSearchFactory /></ProtectedRoute> },
  ];
};

const defaultRoutes = (): RouteObject[] => {
  var routes: RouteObject[] = [
    {
      path: "*",
      element: <PageNotFoundFactory />
    },
    {
      path: "/",
      element: <LoginFactory />
    },
    {
      path: "/unauthorized",
      element: <PageUnauthorizedFactory />
    },
  ];

  return routes;
}

const createRoutesModules = (): RouteObject[] => {
  var routes = defaultRoutes();
  if (applicationData.moduleId === 1) {
    routes.push(...routesSdp());
  } else if (applicationData.moduleId === 9) {
    routes.push(...routesScp());
  } else if (applicationData.moduleId === 10) {
    routes.push(...routesSge());
  } else if (applicationData.moduleId === 3) {
    routes.push(...routesApm());
  }
  return routes;
}

const App = () => {
  let routes = useRoutes(
    createRoutesModules()
  );
  return routes;
}

export default App;
